export const CATEGORIES_ACTION_TYPES = {
    FETCH_CATEGORIES_START: 'category/FETCH_CATEGORIES_START',
    FETCH_CATEGORIES_SUCCESS: 'category/FETCH_CATEGORIES_SUCCESS',
    FETCH_CATEGORIES_FAILED: 'category/FETCH_CATEGORIES_FAILED',
    FETCH_CATEGORIESTITLE_START: 'category/FETCH_CATEGORIESTITLE_START',
    FETCH_CATEGORIESTITLE_SUCCESS: 'category/FETCH_CATEGORIESTITLE_SUCCESS',
    FETCH_CATEGORIESTITLE_FAILED: 'category/FETCH_CATEGORIESTITLE_FAILED',

}